export const ImportDataHeader = [
  {
    label: "Billto Account Number",
    key: "customer_billto_account_number",
  },
  {
    label: "Points to be Awarded",
    key: "points",
  },
  {
    label: "Reason Code",
    key: "transaction_type",
  },
  {
    label: "Customer Facing Description",
    key: "rule_description",
  }
];
